import Head from 'next/head';
import Images from '@/components/Images';

const Page = () => {
  return (
    <>
      <Head>
        <title>Images</title>
      </Head>

      <h1>Images</h1>
      <Images />
    </>
  );
};

export default Page;
